import { Component, h, Prop, Element } from '@stencil/core';

const hover = '#007a8a';
const defaultColor = '#191523';
const darkBg = '#fff';

const svgDimensions: any = {
  width: '20',
  height: '20',
};

/**
 * COMPNAME is designed for rendering icon SVG paths inside the social media menu
 */
@Component({
  tag: 'aafp-social-media-menu-svg',
  shadow: false,
})
export class AafpSocialMediaMenuSvg {
  @Element() element: Element;
  /**
   * material icons svg path
   *
   * (SVG paths can be retrieved from the svgUtils util in component-utils)
   */
  @Prop() pathShape: string;
  /**
   * name of social media menu icon (supported options include: 'facebook', 'twitter', 'download', 'connect', 'instagram', 'youtube', 'linkedin')
   */
  @Prop() iconLabel: any;
  /**
   * optional prop for specifying color of svg
   */
  @Prop({ mutable: true }) fillColor: string = defaultColor;
  /**
   * if true then style options and event handlers are added to ensure component displays with proper styles
   */
  @Prop() hasText: boolean = false;

  onMouseOver() {
    this.fillColor = hover;
  }

  onMouseOut() {
    this.fillColor = defaultColor;
  }

  getFillColor(): string {
    if (this.hasText) return darkBg;
    return defaultColor;
  }

  // renderSocialIcon() {
  //   switch (this.iconLabel) {
  //     case 'twitter':
  //       return this.renderTwitterSvg();
  //   }
  // }

  // renderTwitterSvg() {
  //   return (
  //     <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
  //       <g transform="translate(-1103.000000, -2304.000000)" fill={this.fillColor}>
  //         <g transform="translate(1076.000000, 2278.000000)">
  //           <path d="M52,28.3672371 C51.0804687,28.7686983 50.0914063,29.0401846 49.0539062,29.1624688 C50.1132812,28.5372044 50.9265625,27.5481638 51.309375,26.3691598 C50.31875,26.9475101 49.2203125,27.3674293 48.0523438,27.5943088 C47.1164062,26.612959 45.7835938,26 44.3085938,26 C41.4757812,26 39.1796875,28.2603346 39.1796875,31.049029 C39.1796875,31.4443376 39.225,31.8296481 39.3125,32.199577 C35.0492187,31.9888483 31.2703125,29.9784657 28.740625,26.9236685 C28.2992187,27.6696789 28.0460937,28.5372044 28.0460937,29.4624111 C28.0460937,31.2136128 28.9515625,32.7594693 30.3273438,33.6646799 C29.4867187,33.6385311 28.6960937,33.4116516 28.0046875,33.0332628 C28.0039062,33.0547972 28.0039062,33.0755624 28.0039062,33.0970967 C28.0039062,35.5435493 29.771875,37.5839262 32.11875,38.0476831 C31.6882813,38.1630456 31.2351562,38.2245722 30.7671875,38.2245722 C30.4367188,38.2245722 30.115625,38.1930398 29.8023438,38.1345895 C30.4546875,40.1403576 32.3492187,41.6000769 34.59375,41.6408383 C32.8382813,42.9951932 30.6265625,43.8019612 28.2234375,43.8019612 C27.809375,43.8019612 27.4015625,43.7781196 27,43.7319746 C29.2695312,45.1640069 31.965625,46 34.8625,46 C44.296875,46 49.4554687,38.306095 49.4554687,31.6343011 C49.4554687,31.4151125 49.4507812,31.197462 49.440625,30.9805807 C50.4429688,30.269179 51.3125,29.3801192 52,28.3672371"></path>
  //         </g>
  //       </g>
  //     </g>
  //   );
  // }

  renderPath() {
    const pathAttributes: any = {
      fill: this.fillColor,
      d: this.pathShape,
    };
    return <path {...pathAttributes} />;
  }

  getViewBox() {
    switch (this.iconLabel) {
      case 'download':
        return '0 0 26 26';
      case 'linkedin':
        return '0 0 36 36';
      case 'instagram':
        return '0 0 1000 1000';
      case 'twitter':
        return '0 0 100 100';
      default:
        return '0 0 24 24';
    }
  }

  getClassList(hasText: boolean): string {
    const socialMediaIcon = ['linkedin', 'twitter'].includes(this.iconLabel);
    const baseSelector = hasText
      ? 'adl-social-media-menu-svg__footer-wrapper'
      : 'adl-social-media-menu-svg__default-wrapper';
    if (socialMediaIcon) {
      return [baseSelector, 'adl-social-media-menu-svg__social-icon'].join(' ');
    }
    return baseSelector;
  }

  componentWillRender() {
    if (this.hasText) this.fillColor = darkBg;
  }

  render() {
    if (!this.hasText) {
      this.element.addEventListener('mouseover', this.onMouseOver);
      this.element.addEventListener('mouseout', this.onMouseOut);
    }
    const pathAttributes: any = {
      fill: this.fillColor,
      d: this.pathShape,
    };
    const renderSvgGroup = [''].includes(this.iconLabel);
    const renderSvgPath = !renderSvgGroup;
    svgDimensions.viewBox = this.getViewBox();
    return (
      <div class={this.getClassList(this.hasText)}>
        <svg xmlns="http://www.w3.org/2000/svg" {...svgDimensions}>
          {renderSvgPath && <path fill="none" d="M0 0h24v24H0V0z" />}
          {renderSvgPath && <path {...pathAttributes} />}
          {/* {renderSvgGroup && this.renderSocialIcon()} */}
        </svg>
      </div>
    );
  }
}
